import { render } from "./KnockOutPage.vue?vue&type=template&id=35d8e06f"
import script from "./KnockOutPage.vue?vue&type=script&lang=js"
export * from "./KnockOutPage.vue?vue&type=script&lang=js"

import "./KnockOutPage.vue?vue&type=style&index=0&id=35d8e06f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__